import NextHead from "next/head";
import React from "react";

import { useMeta } from "./useMeta";

export const Head: React.FC = () => {
  const { metaTitle, metaDescription, productSchema, noIndex } = useMeta();
  return (
    <NextHead>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <script
        dangerouslySetInnerHTML={{ __html: JSON.stringify(productSchema) }}
        type="application/ld+json"
      />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
    </NextHead>
  );
};
